const modal: HTMLElement = document.getElementById("info-modal");

const modalHeaderText: HTMLElement = document.getElementById("modal-header-text-p");

const modalText: HTMLElement = document.getElementById("modal-text-p");

const modalDissmissButton: HTMLElement = document.getElementById("modal-dissmiss");

const modalActionButton: HTMLElement = document.getElementById("modal-action-button");

let modalOnAction: Function;

modalDissmissButton.onclick = () => {
    modal.style.display = "none";
};

modalActionButton.onclick = () => {
    modal.style.display = "none";
    if (modalOnAction) {
        modalOnAction();
        modalOnAction = undefined;
    }
};

export const InfoModal: any = {
    open(headerText: string, message: string, onAction: Function, dismissPossible: boolean = false): void {
        modal.style.display = "flex";
        modalHeaderText.innerText = headerText;
        modalText.innerText = message;
        modalOnAction = onAction;

        if (!dismissPossible) {
            modalDissmissButton.style.display = "none";
        } else {
            modalDissmissButton.style.display = "inline-block";
        }
    },

    setActionButtonText(text: string): void {
        modalActionButton.innerText = text;
    },
};



// WEBPACK FOOTER //
// ./src/app/InfoModal.ts